import styled from 'styled-components';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { DATE_BUBBLE_HEIGHT } from './dateBubble.consts';

type DateWrapperProps = {
  bgColor?: ThemeColorType;
};
export const DateWrapper = styled.div<DateWrapperProps>`
  background-color: ${({ bgColor, theme }) => bgColor || theme.colors.bodyBg};
  border-radius: 11px;
  color: ${({ theme }) => theme.colors.absence};
  font-size: 12px;
  font-weight: 600;
  line-height: ${DATE_BUBBLE_HEIGHT}px;
  margin: 0 auto;
  min-width: 120px;
  padding: 0 24px;
  position: relative;
  text-align: center;
  z-index: 1;
`;
